import {
  AllAnalysisData,
  AnalysisPensionScheme,
  AnalysisFunds,
  FundAnalysisData,
  FundCost,
  AppliedAnalysisFilter,
  PaginationMeta,
  Paginated
} from '../types';
import Organisation from '../../../models/Organisation';
import OrganisationType from '../../../models/OrganisationType';
import TimePeriod from '../../../models/TimePeriod';
import { SubFund } from '../../subFund/types';
import { Fund, OrganisationManager } from '../../fund/types';
export interface ICostAnalysisState {
  fetchingData: boolean;
  analysisData: AllAnalysisData;
  fundAnalysisData: FundAnalysisData;
  paginatedFundAnalysis: FundCost[];
  analysisPaginationMeta: PaginationMeta;
  paginatedFunds: Paginated<Fund>;
  allAssetClasses: OrganisationType[];
  allTimePeriods: TimePeriod[];
  allOrganisationTypes: OrganisationType[];
  allAssetManagers: OrganisationManager[];
  allFunds: AnalysisFunds[];
  allExposedFunds: AnalysisFunds[];
  allExposedPensionSchemes: AnalysisPensionScheme[];
  appliedAllAnalysisFilter: AppliedAnalysisFilter;
  filterFunds: AnalysisFunds[];
  filterPensionSchemes: AnalysisPensionScheme[];
  filterAssetClasses: OrganisationType[];
  filterTimePeriods: TimePeriod[];
  filterSubFunds: SubFund[];
  currentOrganisation: Organisation;
}

export const CostAnalysisState: ICostAnalysisState = {
  fetchingData: false,
  analysisData: {} as AllAnalysisData,
  fundAnalysisData: {} as FundAnalysisData,
  analysisPaginationMeta: {} as PaginationMeta,
  paginatedFunds: {} as Paginated<Fund>,
  paginatedFundAnalysis: [],
  allAssetClasses: [],
  allTimePeriods: [],
  allOrganisationTypes: [],
  allAssetManagers: [],
  allFunds: [],
  allExposedFunds: [],
  allExposedPensionSchemes: [],
  appliedAllAnalysisFilter: {
    instanceId: Date.now()
  },
  filterFunds: [],
  filterPensionSchemes: [],
  filterAssetClasses: [],
  filterTimePeriods: [],
  filterSubFunds: [],
  currentOrganisation: {
    id: '',
    name: '',
    organizationType: {
      id: '',
      name: '',
      slug: ''
    },
    owner: '',
    parentOrganization: ''
  }
};
